import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { ImpersonationService } from './impersonation.service';

@Injectable({
  providedIn: 'root'
})
// Responsible for setting the studyId in the ImpersonationService
export class StudyIdResolver implements Resolve<null> {
  constructor(private impersonationService: ImpersonationService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<null> {
    this.impersonationService.studyId = route.params['studyId'];
    return of(null);
  }
}
